module.exports = __webpack_public_path__ + "static/media/Manufacturing.dacd5cd7.svg";